import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './Pages/Home/Home';
import { Explore } from './Pages/Explore/Explore';
import { Detail } from './Pages/Detail/Detail';
import { Reserve } from './Pages/Reserve/Reserve';
import { Confirm } from './Pages/Confirm/Confirm';
import { Thanks } from './Pages/Thanks/Thanks';
import { Plan } from './Pages/Plan/Plan';
import { Privacy } from './Pages/Privacy/Privacy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/explore/'>
          <Route path=":id" element={<Explore id={':id'}/>} />
          <Route path="" element={<Explore />} />

        </Route>
        <Route path='/detail/'>
          <Route path=":id" element={<Detail id={':id'} isDetail={true}/>} />
        </Route>
        <Route path='/plan/'>
          <Route path=":id" element={<Plan id={':id'} />} />
        </Route>
        <Route path='/reserve/'>
          <Route path=":id" element={<Reserve id={':id'}/>} />
        </Route>
        <Route path='/confirm/' element={<Confirm/>} />
        <Route path='/thanks/' element={<Thanks/>} />
        <Route path='/privacy/' element={<Privacy/>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
